module.exports = __webpack_public_path__ + "static/media/man-die-palliatieve-zorg-krijgt-zit-thuis-achter-zijn-computer.550287e2.jpg";